import React from "react";
import Footer from "../../Shared/Footer/Footer";
import Banner from "../Banner/Banner";
import Navbar from "../Navbar/Navbar";
import HeaderNavbar from "../../Shared/Header/HeaderNavbar/HeaderNavbar";
import HeaderNavbarTwo from "../../Shared/Header/HeaderNavbar/HeaderNavbarTwo";

const PageTwo = () => {
  return (
    <>
      <HeaderNavbarTwo />
      <Banner />
      <Footer />
    </>
  );
};

export default PageTwo;
